<div class="font-normal text-[0.8125rem] leading-[1.125rem] text-font-secondary mb-2">
  {{ label() }}
</div>

@if (id()) {
  <div class="flex flex-row items-center gap-1 details-item-id-hover">
    <a [class]="link() ? 'cursor-pointer hover:underline' : ''" [routerLink]="link()">
      {{ id() | notAvailable | rktShortId }}
    </a>

    <button title="Copy ID" class="p-1 text-lg rounded-full hover:bg-gray-200" (click)="copyToClipboard()">
      <rkt-icon [name]="copyFlag() ? 'check' : 'copy'"></rkt-icon>
    </button>
  </div>
} @else {
  <div class="text-font-muted font-normal">{{ id() | notAvailable }}</div>
}
